import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const fetchOnboardingOrdersDone = (state, { payload }) => {
    return {
        ...state, orders : payload, fetchOrdersLoading : false
    }
}

const saveOrderIdDone = (state, { payload }) => {
    return {
        ...state, orderId: payload
    }
}

const fetchOnboardingOrderDetailsDone = (state, { payload }) => {
    return {
        ...state, orderDetails : payload
    }
}

const clearOrderDetails = (state) => {
    return {
        ...state, orderDetails : {}
    }
}
const clearOrders = (state) => {
    return {
        ...state, orders : {}, orderDetails : {}, orderId : '', fetchingOrders : false
    }
}
const fetchOnboardingOrderDetailsLoading = (state, {payload}) => {
    return {
        ...state, fetchDetailsLoading : payload
    }
}
const fetchOrdersLoading = (state, {payload}) => {
    return {
        ...state, fetchOrdersLoading : payload
    }
}
const setOnBoardingOrderChecklistDetails = (state, { payload }) => {
    let checklist = state.orderDetails.suiteOnBoardingChecklist.map((cl) => {
        if(cl.id === payload.id) {
            return { ...cl, ischecked : payload.ischecked}
        } else {
            return cl
        }
    })
    return {
        ...state, orderDetails : { ...state.orderDetails, suiteOnBoardingChecklist : checklist}
    }
}

const setOnBoardingOrderChecklistDocuments = (state, { payload }) => {
    let checklist = state.orderDetails.suiteOnBoardingChecklist.map((cl) => {
        if(cl.id === payload.checklistId) {
            return { ...cl, suiteOnBoardingChecklistDocuments : [...cl.suiteOnBoardingChecklistDocuments, ...payload.documents]}
        } else {
            return cl
        }
    })
    return {
        ...state, orderDetails : { ...state.orderDetails, suiteOnBoardingChecklist : checklist}
    }
}
const deleteOnboardingChecklistDocument = (state, { payload }) => {
    let checklist = state.orderDetails.suiteOnBoardingChecklist.map((cl) => {
        if(cl.id === payload.checklistId) {
            let docs = cl.suiteOnBoardingChecklistDocuments.filter(cld => cld.id !== payload.documents[0].id )
            return { ...cl, suiteOnBoardingChecklistDocuments : docs}
        } else {
            return cl
        }
    })
    return {
        ...state, orderDetails : { ...state.orderDetails, suiteOnBoardingChecklist : checklist}
    }
}
const setOnBoardingOrderChecklistNotes = (state, { payload }) => {
    let checklist = state.orderDetails.suiteOnBoardingChecklist.map((cl) => {
        if(cl.id === payload.checklistId) {
            return { ...cl, suiteOnBoardingChecklistNotes : [payload.notes]}
        } else {
            return cl
        }
    })
    return {
        ...state, orderDetails : { ...state.orderDetails, suiteOnBoardingChecklist : checklist}
    }
}
const saveConveyanceForm = (state, { payload }) => {
    return {
        ...state, fetchConveyanceForm : [payload],
    }
}
const clearConveyanceForm = (state, { payload }) => {
    return {
        ...state, fetchConveyanceForm : [],
    }
}
const saveConveyanceFormData = (state, { payload }) => {
    return {
        ...state, fetchConveyanceFormData : payload,
    }
}
const clearSaveConveyanceFormData = (state, { payload }) => {
    return {
        ...state, fetchConveyanceForm : payload,
    }
}
const initialState = {
    orders : [],
    orderId : '',
    orderDetails: {},
    fetchDetailsLoading: false,
    fetchOrdersLoading: false,
    fetchConveyanceForm:[],
    fetchConveyanceFormData:{
        email:'',
        fax:'',
        financialInstitutionBank:'',
        homeOwner:'',
        id:'',
        lawFirmNotary:'',
        lawyerNotaryContactName:'',
        mailingAddress:'',
        phone:'',
        propertyName:'',
        stratalot:'',
        suiteName:'',
    },
}

export default createReducer(initialState, {
    [TYPES.FETCH_ONBOARDING_ORDERS] : fetchOnboardingOrdersDone,
    [TYPES.SAVE_ONBOARDING_ORDER_ID]: saveOrderIdDone,
    [TYPES.FETCH_ONBOARDING_ORDER_DETAILS]: fetchOnboardingOrderDetailsDone,
    [TYPES.CLEAR_FETCH_ONBOARDING_ORDER_DETAILS]: clearOrderDetails,
    [TYPES.FETCH_ONBOARDING_ORDER_DETAILS_LOADING]: fetchOnboardingOrderDetailsLoading,
    [TYPES.SET_ONBOARDING_ORDER_CHECKLISTDETAILS]: setOnBoardingOrderChecklistDetails,
    [TYPES.SET_ONBOARDING_ORDER_CHECKLIST_DOCUMENTS]: setOnBoardingOrderChecklistDocuments,
    [TYPES.SET_ONBOARDING_ORDER_CHECKLIST_NOTES]: setOnBoardingOrderChecklistNotes,
    [TYPES.CLEAR_FETCH_ONBOARDING_ORDERS]: clearOrders,
    [TYPES.FETCH_ORDERS_LOADING]: fetchOrdersLoading,
    [TYPES.DELETE_ONBOARDING_ORDER_CHECKLIST_DOCUMENTS]: deleteOnboardingChecklistDocument,
    [TYPES.FETCH_CONVEYANCE_FORM]: saveConveyanceForm,
    [TYPES.CLEAR_CONVEYANCE_FORM]: clearConveyanceForm,
    [TYPES.FETCH_CONVEYANCE_FORM_DATA]: saveConveyanceFormData,
    [TYPES.CLEAR_FETCH_CONVEYANCE_FORM_DATA]: clearSaveConveyanceFormData,




})